import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditSchemaEvolution = () => {
    const { id } = useParams(); // Get the ID from the URL
    const [targetCode, setTargetCode] = useState('');
    const [targetOn, setTargetOn] = useState('');
    const [target, setTarget] = useState('');
    const [actual, setActual] = useState('');
    const [incentiveRate, setIncentiveRate] = useState('');
    const [incentiveAmount, setIncentiveAmount] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Fetch the schema evolution details when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}schemaevolutions/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    // Set the state with the data fetched from the API
                    setTargetCode(data.data.target_code);
                    setTargetOn(data.data.target_on);
                    setTarget(data.data.target);
                    setActual(data.data.actual);
                    setIncentiveRate(data.data.incentive_rate);
                    setIncentiveAmount(data.data.incentive_amount);
                } else {
                    setError('Error fetching schema evolution details.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setError('Error fetching schema evolution details.');
            });
    }, [id]);

    // Handle input field changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "targetCode") setTargetCode(value);
        if (name === "targetOn") setTargetOn(value);
        if (name === "target") setTarget(value);
        if (name === "actual") setActual(value);
        if (name === "incentiveRate") setIncentiveRate(value);
        if (name === "incentiveAmount") setIncentiveAmount(value);
    };

    // Handle form submission to update schema evolution
    const handleSubmit = (event) => {
        event.preventDefault();

        // Validate the form
        if (!targetCode || !targetOn || !target || !actual || !incentiveRate || !incentiveAmount) {
            setError('Please fill in all fields.');
            return;
        }

        // Prepare the data to be sent in the PUT request
        const data = {
            target_code: targetCode,
            target_on: targetOn,
            target: parseFloat(target),
            actual: parseFloat(actual),
            incentive_rate: parseFloat(incentiveRate),
            incentive_amount: parseFloat(incentiveAmount),
        };

        // Send PUT request to update the schema evolution
        fetch(`${BASE_URL}schemaevolutions/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    // Redirect to the list page after successful update
                    navigate('/SchemaEvolutionsListPage');
                } else {
                    setError('Error updating schema evolution.');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setError('Error updating schema evolution.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Schema Evolution</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form to Edit Schema Evolution */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Schema Evolution</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="targetCode" className="form-label">Target Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="targetCode"
                                            name="targetCode"
                                            value={targetCode}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="targetOn" className="form-label">Target On</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="targetOn"
                                            name="targetOn"
                                            value={targetOn}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="target" className="form-label">Target</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="target"
                                            name="target"
                                            value={target}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="actual" className="form-label">Actual</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="actual"
                                            name="actual"
                                            value={actual}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="incentiveRate" className="form-label">Incentive Rate (%)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="incentiveRate"
                                            name="incentiveRate"
                                            value={incentiveRate}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="incentiveAmount" className="form-label">Incentive Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="incentiveAmount"
                                            name="incentiveAmount"
                                            value={incentiveAmount}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Update Schema Evolution</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditSchemaEvolution;
